import React from "react";
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';

const Connector = (Component) => {

/**
 * Provide project id and project slug from location's state. Already includes hoc withRouter
 * @component
 * @category HOC
 * @param providedProps
 * @param {number} providedProps.navigationState - state of html5 history
 * 
*/

  const WithKeepNavigationState = (Component) => {

    class WithKeepNavigationState extends React.Component {

      constructor(props) {
        super(props);

        const { location: { state } } = props;

        this.navigationState = state;
      }

      render() {
        return <Component { ...this.props } 
                          navigationState = { this.navigationState } />
      }
    }

    return WithKeepNavigationState;
  };

  return compose(withRouter, WithKeepNavigationState)(Component);
}

export default Connector;
